import { useEffect } from "react";
import { PlusCircleIcon, BookOpenIcon } from "@heroicons/react/solid";
import { useDispatch, useSelector } from "react-redux";
import { deleteCategoryAction, fetchDetailCategoryAction, updateCategoryAction } from "../../Redux/Slices/category/categorySlice";

import * as Yup from "yup";

import { useFormik } from "formik";
import { useParams } from "react-router-dom";

import {  useNavigate } from "react-router-dom";




//Form schema
const formSchema = Yup.object({
  title: Yup.string().required("Title is required"),
 
});

const UpdateCategory = () => {
  const params = useParams()
  const navigate = useNavigate()

  const {id} = params  

  const dispatch = useDispatch()



/// get data from store

const categoryState = useSelector(state => state?.category)

const {loading, appErr, serverErr, fetchSingleCategory, updateCategory, isEdited, isDeleted } = categoryState

//console.log(fetchSingleCategory)
//const {title} = fetchSingleCategory
  // fetch single category 

useEffect(()=>{
  dispatch(fetchDetailCategoryAction(id))

    

}, [dispatch, id])

  //formik
  const formik = useFormik({
    enableReinitialize: true.valueOf,
    initialValues: {
      title: fetchSingleCategory?.title,
      
    },
    onSubmit: values => {
      // build up the data for update
            //dispath the action
      dispatch(updateCategoryAction({title: values.title, id}))
      

      //console.log(values);
    },
    validationSchema: formSchema,
  });



//console.log(title)

if(isEdited || isDeleted){
      //<Navigate to="/profile" replace={true} />
      navigate("/category-list")
      
    }


  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full space-y-8">
        <div>
          <BookOpenIcon className="mx-auto h-12 w-auto" />
          <h2 className="mt-6 text-center text-3xl font-extrabold text-gray-900">
            Edit Category
          </h2>
          <p className="mt-2 text-center text-sm text-gray-600">
            <p className="font-medium text-indigo-600 hover:text-indigo-500">
              These are the categories user will select when creating a post
            </p>
            {/* display error */}

            <div>
            {appErr|| serverErr ? <h2 className="text-red-500 text-center">{appErr} - {serverErr} </h2> : null }
            </div>


          </p>
        </div>
        {/* Form */}
        <form onSubmit={formik.handleSubmit} className="mt-8 space-y-6">
          <input type="hidden" name="remember" defaultValue="true" />
          <div className="rounded-md shadow-sm -space-y-px">
            <div>
              <label htmlFor="email-address" className="sr-only">
                Name
              </label>
              {/* Title */}
              
              <input
                value={formik.values.title}
                onChange={formik.handleChange("title")}
                onBlur={formik.handleBlur("title")}
                type="text"
                autoComplete="text"
                className="appearance-none rounded-none relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-t-md focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 text-center focus:z-10 sm:text-sm"
                placeholder='title'
              />
              <div className="text-red-400 mb-2">
                {formik.touched.title && formik.errors.title} 
              </div>
            </div>
          </div>

          <div>
            <div>
              {/* Submit */}
              {
                loading ? <button
                
                disabled                
                className="group relative w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-slate-700 "
              
              >
                <span className="absolute left-0 inset-y-0 flex items-center pl-3">
                  <PlusCircleIcon
                    className="h-5 w-5 text-yellow-500 group-hover:text-indigo-400"
                    aria-hidden="true"
                  />
                </span>
                Updating Category...
              </button> :(
                <>
                <button
                type="submit"
                className="group relative w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-yellow-600 hover:bg-yellow-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
              >
                <span className="absolute left-0 inset-y-0 flex items-center pl-3">
                  <PlusCircleIcon
                    className="h-5 w-5 text-yellow-500 group-hover:text-indigo-400"
                    aria-hidden="true"
                  />
                </span>
                Update Category
              </button>
              <button
              onClick={()=>dispatch(deleteCategoryAction(id))}
                type="submit"
                className="group mt-2 relative w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-red-600 hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
              >
                
                delete Category
              </button>
                
                </>
              )
              
              }
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};

export default UpdateCategory;
